import SelectedPreview from './SelectedPreview';
import Price from './Price';
import Generation from './Generation';
import BtnSelectAll from '../images/btn_selectall.png';
import BtnMint from '../images/btn_mint.png';
import BtnMintDisable from '../images/btn_mint_disable.png';
import BtnOpensea from '../images/btn_opensea.png';
import { useSelector } from "react-redux";
import { useState } from 'react';
import BigNumber from 'bignumber.js';

export default function Action(props) {
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [message, setMessage] = useState('');

  function allSelect() {
    props.allSelect();
  }

  function mint() {
    setMessage('')
    const mintCount = BigNumber(props.selectedCharacter.length.toString()).plus(data.whitelistMinted)
    if (data.phase === '1' && mintCount.gt(BigNumber(data.maxMintSupply))) {
      const canMintCount = BigNumber(data.maxMintSupply).minus(data.whitelistMinted).toString()
      setMessage(props.lang === 'ja' ? `本セールではあと${canMintCount}体までしか購入できません` : `You can only purchase ${canMintCount} more Characters from this sale.`)
      return
    }
    props.mint(props.lang === 'ja' ? '' : '');
  }

  function canMint() {
    return blockchain.account !== "" && blockchain.smartContract !== null && ((data.phase === '2') || (data.phase === '1' && data.whitelisted && Number.parseInt(data.whitelistMinted) < 28)) && Number.parseInt(data.totalSupply) < Number.parseInt(data.maxSupply)
  }

  function showOS() {
    return BigNumber(data.balance).gt(BigNumber('2')) || BigNumber(data.totalSupply).gt(BigNumber(data.maxSupply))
  }

  function openSea() {
    window.open('https://opensea.io/collection/isekai-battle', '_blank')
  }

  return (
    <>
      <div className="action">
        <div className='action__wrapper'>
          <h3>{props.lang === 'ja' ? '選択したキャラクター' : 'Hire the selected Characters (Mint)'}</h3>

          {/* 選択したキャラが入る部分 */}
          <SelectedPreview
            removeCharacter={props.removeCharacter}
            selectedCharacter={props.selectedCharacter}
            fewerFlag={props.fewerFlag}
            CharacterList={props.CharacterList}
            lang={props.lang}
            message={message}
          />

          {/* 世代表示 */}
          <Generation lang={props.lang} />

          {/* キャラ全選択 */}
          <button className="btn btn__all-characters" onClick={allSelect}>
            <img src={BtnSelectAll} alt="Select all Characters" />
          </button>

          {/* 価格表示 */}
          <Price selectedCharacter={props.selectedCharacter} lang={props.lang} />

          {/* Mintボタン */}
          <button disabled={!canMint()} className="btn btn__mint" onClick={mint}><img src={canMint() ? BtnMint : BtnMintDisable} alt="Mint" /></button>
          {showOS() &&
            <button className="btn btn__opensea" onClick={openSea}><img src={BtnOpensea} alt="Opensea" /></button>
          }
          <small className='notice'>{props.lang === 'ja' ? '本ゲームをプレイするにはキャラクターが3体以上必要です。' : 'You will need 3 or more characters to play the game.'}</small>
          <small className='notice'>{props.lang === 'ja' ? '本ゲームはPCブラウザ推奨となります' : 'This game is recommended to be played on a PC browser.'}</small>
        </div>
      </div>
    </>
  );
}

